import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink, RouterLink} from "@irati/ui/src/Link"
import {Body, H1, H3} from "@irati/ui/src/Typography"
import React from "react"
import styled, {css} from "styled-components"

const ThankYouScreen = () => {
  return (
    <BackgroundImage>
      <CenterContainer>
        <MessageHeader marginTop={5} textAlign="center">
          Thank you for choosing Vivup!
        </MessageHeader>
        <Message>
          Your order is now being processed. You will receive an email notification confirming your order and next steps. You can find the
          status of your order in your account section.
        </Message>
        <H3 margin={4.4} textAlign="center">
          Order ID: 1
        </H3>
        <Flex justifyContent="center">
          <MyOrderButton primary to="/">
            My orders
          </MyOrderButton>
        </Flex>
        <RouterLink to="/">
          <Body textDecoration="underline" textAlign="center" maxWidth="100%" marginTop={2}>
            Take me home
          </Body>
        </RouterLink>
      </CenterContainer>
    </BackgroundImage>
  )
}

export default ThankYouScreen

const BackgroundImage = styled.div`
  display: flex;
  justify-content: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-image: url("https://dev-assets.cdn.vivup.co.uk/en-GB/thankYou/thank-you.jpg");
  position: absolute;
`

const CenterContainer = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.white};
    border-radius: 15px;
    margin-top: 75px;
    margin-bottom: 47px;
    $box-shadow: 0rem 0.1875rem 0.375rem #00000029;
    width: 344px;
    height: 447px;

    ${theme.mediaQueries.minWidthMedia.desktop`
      width: 655px;
      height: 373px;
    `}
  `}
`

const MessageHeader = styled(H1)`
  font-size: 24px;
  max-width: 240px
    ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
      max-width: 0;
  `};
  color: ${({theme}) => theme.colors.primary2};
` as typeof H1

const Message = styled(Body)`
  ${({theme}) => css`
    margin-top: 18px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    max-width: 93%;
    line-height: 18px;

    ${theme.mediaQueries.minWidthMedia.desktop`
      font-size: 16px;
      max-width: 552px;
      line-height: 20px;
    `};
  `}
`

const MyOrderButton = styled(ButtonRouterLink)`
  width: 100%;
  max-width: 350px;
  margin-left: 24px;
  margin-right: 24px;
` as typeof ButtonRouterLink
